import Alpine from 'alpinejs'
import { getLenis } from '@/lib/lenis'

export function handleHashScroll(destination?: string) {
	const hash = window.location.hash.slice(1)
	if (!hash && !destination) return

	const target = document.getElementById(hash || destination!)
	if (!target) return

	window.requestAnimationFrame(() => {
		setTimeout(() => {
			const targetTop = target.getBoundingClientRect().top + window.scrollY
			const hasAnnouncement = (Alpine.store('site') as any)?.showAnnouncement
			const offset = hasAnnouncement ? -90 : -60

			getLenis()?.scrollTo(targetTop, {
				offset,
				duration: 1,
				immediate: false,
				lock: true,
			} as any)
		}, 500)
	})
}

export function checkForHashLinks() {
	const links = document.querySelectorAll('[data-button-scroll-trigger]')

	const hashLinks = Array.from(links).filter((link) => {
		return (
			link.hasAttribute('data-button-scroll-trigger') && link.hasAttribute('data-destination')
		)
	})

	hashLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			const destination = link.getAttribute('data-destination')
			if (destination) {
				handleHashScroll(destination)
			}
		})
	})
}
